import { EvaluationMilestoneCreate } from 'src/screens/shared/project/details/effectivity-management/evaluation-milestone/edit/EvaluationMilestoneCreate'

export const PfPgvEvaluationMilestoneCreatePage = () => {
  return <EvaluationMilestoneCreate baseUrl="/pf-pgv" />
}
